<div class="dialog">
    <div class="dialog-header">
        编卷
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 案卷题名
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <input type="text" [(ngModel)]="record.title" placeholder="请输入案卷题名">
                </div>
            </div>
            <div class="row validate" *ngIf="volumeType !== ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">
                    卷内文件
                </div>
                <div class="column background-module" [style.width]="300 + 'px'">
                    <select [(ngModel)]="record.fileRule" [disabled]="true">
                        <option [value]="undefined" [disabled]="true">选择卷内文件规则</option>
                        <option [value]="ArchiveVolumeFileRule.FULL_FILES">
                            {{ArchiveVolumeFileRuleMap[ArchiveVolumeFileRule.FULL_FILES]}}
                        </option>
                        <option [value]="ArchiveVolumeFileRule.MANUAL_SELECT">
                            {{ArchiveVolumeFileRuleMap[ArchiveVolumeFileRule.MANUAL_SELECT]}}
                        </option>
                    </select>
                </div>

                <div class="column background-page" [style.width]="80 + 'px'">
                    起止日期
                </div>
                <div class="column color-light" [style.width]="100 + 'px'">
                    <nz-date-picker [(ngModel)]="record.fileFinishDateFromDate" [nzSuffixIcon]="''"
                        [nzFormat]="'yyyy-MM-dd'" [nzDisabled]="true">
                    </nz-date-picker>
                </div>
                <div class="column color-light" [style.width]="20 + 'px'">
                    ~
                </div>
                <div class="column color-light" [style.width]="100 + 'px'">
                    <nz-date-picker [(ngModel)]="record.fileFinishDateToDate" [nzSuffixIcon]="''"
                        [nzFormat]="'yyyy-MM-dd'" [nzDisabled]="true">
                    </nz-date-picker>
                </div>
            </div>

            <ng-container
                *ngIf="record.createType === ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="row" *ngFor="let single of unitCascaderValues; let index = index">
                    <div *ngIf="index === 0" class="column background-page spin wbs-section-label"
                        [style.width]="100 + 'px'" [style.height]="unitCascaderValues.length * 40 + 'px'">
                        卷内文件
                    </div>
                    <div class="column background-page" [style.width]="100 + 'px'"></div>
                    <div class="column background-module wbs-section-selector" [style.width]="600 + 'px'">
                        <nz-cascader [nzOptions]="unitCascaderOptions[index] || []" [ngModel]="single"
                            (ngModelChange)="onUnitCascaderChange(index, $event)" [nzShowSearch]="true"
                            nzPlaceHolder="请选择WBS部位">
                        </nz-cascader>
                    </div>
                </div>
            </ng-container>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 卷内排序
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <nz-select class="{{sortOrder.length === 0 ? 'invalidate' : ''}}" [(ngModel)]="sortOrder"
                        [nzOptions]="ArchiveOrderFieldOptions" nzMode="multiple" [nzPlaceHolder]="'请选择排序方式'"
                        (ngModelChange)="onOrderSelected()">
                    </nz-select>
                </div>
            </div>
            <div class="row" *ngIf="volumeType === ArchiveVolumeType.REGULAR">
                <div class="column background-page" [style.textAlign]="'center'" [style.height]="120 + 'px'"
                    [style.width]="100 + 'px'">
                    表单代号<br />
                    排序设置
                </div>
                <div class="column background-module" [style.width]="600 + 'px'" [style.height]="120 + 'px'">
                    <nz-select [nzDisabled]="!fileOrderEnabled" [(ngModel)]="fileOrder" [nzOptions]="fileCodeOrder"
                        nzMode="multiple" [nzPlaceHolder]="'请选择排序方式'" (ngModelChange)="onFileOrderSelected()">
                    </nz-select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 保管期限
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <select [(ngModel)]="record.keepPeriodType">
                        <option *ngFor="let item of ArchiveKeepPeriodTypeOptions" [value]="item.value">
                            {{item.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 起止时间
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)">
                    </nz-range-picker>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    备注
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <input type="text" [(ngModel)]="record.comment" placeholder="请输入备注">
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>